import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv1010SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    filterStatus: z.string().optional(),
    partyId: z.coerce.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv1010SearchParams = z.infer<typeof Inv1010SearchParamsSchema>

export const Inv1010SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string(),
  date: z.coerce.date(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
})

export type Inv1010SearchResultModel = z.infer<
  typeof Inv1010SearchResultModelSchema
>

export const Inv1010SearchResultSchema = z
  .object({
    data: z.array(Inv1010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv1010SearchResult = z.infer<typeof Inv1010SearchResultSchema>
